module.exports = __webpack_public_path__ + "static/media/workforce_energies_logo.6b91bb03.png";